import { render, staticRenderFns } from "./ChangeCard.vue?vue&type=template&id=9b4729d2&"
import script from "./ChangeCard.vue?vue&type=script&lang=js&"
export * from "./ChangeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports